<template>
  <div id="cart-finish" v-if="isImagefinish">
    <div class="cart-finish-header">
      <p>訂單重新生效</p>
      <p>訂單重新生效的明細以及金額如下，請再次確認後即可重新下單。</p>
    </div>
    <div class="main-content">
      <div class="shopping-detail">
        <h2 class="shopping-list">購物明細</h2>
        <div class="order-list-wrap">
          <div
            class="order-list"
            v-for="(item, index) in products"
            :key="index"
          >
            <div class="item-img">
              <img v-bind:src="item.image_url" alt="item" />
            </div>
            <div class="item-name">
              <span>{{ item.shape }}-{{ item.style }}</span>
              <span
                >{{ item.length }}{{ item.unit }}{{ item.weight }}錢{{
                  item.way
                }}</span
              >
            </div>
            <div class="item-amount">
              <span class="mobile-display">數量：</span>
              <span>{{ item.amount }}</span>
              <span class="pc-display">個</span>
            </div>
            <div class="item-price">
              <span class="mobile-display">金額：</span>
              <span>
                TWD
                {{
                  singleProductSum(
                    item.price,
                    item.accessory_price,
                    item.amount
                  )
                }}
              </span>
            </div>
            <div class="item-accessory">
              <span>其他配件:</span>
              <span
                >{{ item.accessory_name === null ? "無" : item.accessory_name }}
                (TWD
                {{
                  item.accessory_price === null ? "0" : item.accessory_price
                }})</span
              >
            </div>
          </div>
          <div class="calculate">
            <div class="calculate-total-title">
              <span>小計</span>
            </div>
            <div class="calculate-total">
              <span>TWD {{ orderDetail.sum }}</span>
            </div>
            <div class="calculate-delivery-title">
              <span>運費</span>
            </div>
            <div class="calculate-delivery">
              <span>TWD {{ orderDetail.freight }}</span>
            </div>
          </div>
          <div class="total-payment-wrap">
            <div>
              <span>總額</span>
              <span v-if="this.$store.getters.getSpecialMemberState !== 1"
                >(包含營業稅)</span
              >
            </div>
            <div class="total-payment">
              <span>TWD {{ orderDetail.sum }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="order-detail">
        <h2>訂單明細</h2>
        <div>
          <h3>訂單編號 {{ orderDetail.trade_no }}</h3>
          <p>成立時間：{{ orderDetail.created_at }}</p>
        </div>
        <div>
          <h3>付款方式</h3>
          <p>ATM轉帳</p>
        </div>
        <div class="delivery">
          <h3>寄送資訊</h3>
          <p>寄送地區：{{ orderDetail.country }}</p>
          <p>
            寄送地址：{{ orderDetail.postal_code
            }}{{ $store.getters.getCityByZipcode(orderDetail.postal_code)
            }}{{ orderDetail.address }}
          </p>
          <p>寄送方式：{{ orderDetail.send_way }}</p>
        </div>
        <div class="receiver">
          <h3>收貨人資訊</h3>
          <p>收件人：{{ orderDetail.full_name }}</p>
          <p>手機：{{ orderDetail.phone }}</p>
          <p>電子信箱：{{ orderDetail.email }}</p>
        </div>
        <div class="invoice">
          <h3>發票資訊</h3>
          <p>發票種類 : {{ orderDetail.invoice_type }}</p>
          <p>抬頭 : {{ orderDetail.invoice_head }}</p>
          <p>統一編號：{{ orderDetail.invoice_num }}</p>
        </div>
      </div>
    </div>
    <div class="button">
      <button @click="checkout">確認結帳</button>
    </div>
  </div>
  <div class="load" v-else>
    <div class="line"></div>
    <div class="line"></div>
    <div class="line"></div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "CartRenew",
  data() {
    return {
      orderDetail: "",
      products: "",
      isImagefinish: false,
    };
  },
  created() {
    this.orderDetail = this.$store.getters.getrenewOrderData;
    this.products = this.orderDetail.order_items;
    this.products.forEach((item) => {
      item.way = this.$store.getters.getTransformWay(item.way);
      item.unit = this.$store.getters.getTransformUnit(item.unit);
    });
    this.baseToImg();
  },
  watch: {
    products: {
      handler() {
        if (typeof this.products !== "undefined") {
          //check img loading
          let checkNum = 0;
          this.products.forEach((item) => {
            if (item.image_url.substring(0, 4) == "data") {
              checkNum = checkNum + 1;
            }
          });
          if (checkNum == this.products.length) {
            this.isImagefinish = true;
          }
        }
      },
      deep: true,
    },
  },
  methods: {
    baseToImg() {
      this.products.forEach((item) => {
        axios({
          url: `${item.image_url}`,
          method: "get",
        })
          .then((response) => {
            item.image_url = response.data;
          })
          .catch((e) => {
            alert(`錯誤訊息：${e.response.data.message}，請重新檢查`);
          });
      });
    },
    async checkout() {
      try {
        let res = await this.$store.dispatch("renewCheckout", {
          oldId: this.$route.params.oldId,
          newId: this.$route.params.newId,
        });
        alert("訂單重新生效成功，請至會員訂單中查看");
        if (this.$store.getters.getDeviceSize < 585) {
          this.$router.push("/gold/member_mobile/member_order");
        } else {
          this.$router.push("/gold/member/member_order");
        }
      } catch (e) {
        alert(`錯誤訊息：${e.response.data.message}，請重新檢查`);
      }
    },
  },
  computed: {
    singleProductSum() {
      return function (productPrice, accessoryPrice, amount) {
        if (accessoryPrice === null) {
          return parseInt(productPrice) * amount;
        } else {
          return parseInt(productPrice) * amount + accessoryPrice * amount;
        }
      };
    },
  },
};
</script>
<style scoped lang="scss">
#cart-finish {
  padding: 110px 120px;
  color: $secondaryDeepColor1;
  @include betweenTableTablePro {
    padding: 110px 30px;
  }
  @include table {
    padding: 90px 16px;
  }
  .cart-finish-header {
    border-bottom: 1px solid $primaryDeepColor;
  }
  .cart-finish-header p:nth-of-type(1) {
    font-size: 24px;
    font-weight: bold;
    margin: 16px;
  }
  .cart-finish-header p:nth-of-type(2) {
    font-size: 17px;
    font-weight: 600;
    margin: 0;
    margin-bottom: 16px;
  }
  .note {
    color: $secondaryColor2;
  }
  .check {
    height: 70px;
    width: 70px;
    margin: 0 auto;
    img {
      width: 100%;
    }
  }
}
.same-trade {
  padding: 25px 10px;
  border-bottom: 1px solid $primaryDeepColor;
  .same-trade-content {
    background-color: rgba($primaryDeepColor, 0.2);
    text-align: center;
    font-size: 17px;
    padding-top: 20px;
    padding-bottom: 28px;
  }
  .grid-container {
    display: grid;
    grid-template-columns: auto auto;
    grid-row-gap: 5px;
    grid-column-gap: 15px;
  }
  .ATM-title {
    font-size: 20px;
    margin-bottom: 15px;
  }
  .transfer-title {
    text-align: right;
  }
  .transfer-text {
    text-align: left;
  }
}
.shopping-detail {
  text-align: left;
  flex-basis: 40%;
  @include table {
    max-width: 600px;
    margin: 0 auto;
    flex-basis: 100%;
  }

  h2 {
    color: $secondaryDeepColor1;
    font-size: 24px;
    line-height: 31px;
    padding: 16px 0px 16px 0px;
    margin: 0;
    display: block;
  }
  .shopping-list {
    border-bottom: 1px solid $primaryDeepColor;
  }
  span {
    font-size: 17px;
  }
}

.main-content {
  display: flex;
  flex-direction: row-reverse;
  border-bottom: 1px solid $primaryDeepColor;

  @include table {
    flex-wrap: wrap;
  }
}

.order-list {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  grid-template-rows: 1fr auto;
  align-items: center;
  color: $secondaryDeepColor1;
  border-bottom: 1px solid $primaryDeepColor;
  font-size: 15px;
  justify-content: space-between;
  padding: 16px;
  @include table {
    padding: 0;
    grid-template-columns: 1fr;
  }

  .item-img {
    grid-column: 1 / span 3;
    @include table {
      grid-column: 1;
    }

    img {
      width: 40px;
      height: auto;
      vertical-align: middle;
      padding: 16px 16px 16px 0;
      @include table {
        padding: 16px;
      }
    }
    p {
      display: inline-block;
    }
  }

  .item-name {
    padding-bottom: 16px;
    span {
      display: block;
    }
  }
  .item-amount {
    text-align: center;
    line-height: 31px;
    @include table {
      text-align: left;
    }
  }
  .item-price {
    text-align: right;
    line-height: 31px;
    @include table {
      text-align: left;
    }
  }
  .item-accessory {
    grid-column-start: 1;
    grid-column-end: 4;
    @include table {
      grid-column-start: 1;
      grid-column-end: 1;
    }
  }
}

.calculate {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto;
  color: $secondaryDeepColor1;
  font-size: 15px;
  padding: 16px;
  @include table {
    padding: 0;
  }
  .calculate-total-title {
    span {
      display: block;
      padding-top: 16px;
    }
  }
  .calculate-delivery-title {
    span {
      display: block;
      padding-top: 16px;
      padding-bottom: 32px;
    }
  }
  .calculate-total {
    text-align: right;
    span {
      display: block;
      padding-top: 16px;
    }
  }
  .calculate-delivery {
    text-align: right;
    span {
      display: block;
      padding-top: 16px;
      padding-bottom: 32px;
    }
  }
}
.total-payment-wrap {
  display: grid;
  grid-template-columns: 1fr auto;
  color: $secondaryDeepColor1;
  align-items: center;
  padding-top: 16px;
  padding-bottom: 16px;
  border-top: 1px solid $primaryDeepColor;
  @include table {
    padding-left: 0;
  }

  span {
    display: inline-block;
    font-weight: 800;
  }
  .total-payment {
    font-size: 24px;
    text-align: right;
    padding-left: 7px;
  }
}

.pc-display {
  display: inline-block;
  @include table {
    display: none;
  }
}
.mobile-display {
  display: none;
  @include table {
    display: inline-block;
  }
}

.order-detail {
  padding-bottom: 16px;
  flex-basis: 60%;
  text-align: left;
  h3 {
    font-size: 17px;
  }
  @include table {
    flex-basis: 100%;
    max-width: 600px;
    margin: 0 auto;
  }
}

.delivery,
.receiver,
.invoice {
  p {
    margin: 0;
    line-height: 28px;
  }
  a {
    color: #4a90e2;
    display: inline-block;
    text-decoration: underline;
  }
}
button {
  @extend %button;
  margin-top: 29px;
}
//loading
.load {
  padding-top: 25vh;
  text-align: center;
}
.load .line:nth-last-child(1) {
  animation: loadingC 0.6s 0.1s linear infinite;
}
.load .line:nth-last-child(2) {
  animation: loadingC 0.6s 0.2s linear infinite;
}
.load .line:nth-last-child(3) {
  animation: loadingC 0.6s 0.3s linear infinite;
}
.line {
  display: inline-block;
  width: 15px;
  height: 15px;
  margin: 3px;
  border-radius: 15px;
  background-color: #a8894c;
}
@keyframes loadingC {
  0% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(0, 15px);
  }
  100% {
    transform: translate(0, 0);
  }
}
</style>
